<!-- 显示科室号源 -->
<template>
  <div v-wechat-title='(remoteData && remoteData.department && remoteData.department.name) ? remoteData.department.name :"科室"'>
    <md-tab-bar v-model="currentDateBar" :items="remoteData.dateList" @change="onDateBarChange">
      <template slot="item" slot-scope="{ item }">
        <div class="customDateBar">{{ item.label.split(' ')[0] }}<br/>{{ item.label.split(' ')[1] }}</div>
      </template>
    </md-tab-bar>

    <div v-if="!filterDoctorIdList || filterDoctorIdList.length === 0" class="">
      <md-field>
        <md-skeleton avatar title :loading="remoteDataLoading">
          <md-cell-item>未找到出诊医生</md-cell-item>
          <md-cell-item v-if="this.remoteError"> {{this.remoteError}} </md-cell-item>
        </md-skeleton>
      </md-field>
    </div>

    <md-field v-for="doctor of doctorListByComputed" :key="doctor.id">
      <md-cell-item :title="doctor.name" :brief="doctor.title" addon="">
        <span class="holder" slot="left">{{doctor.name[0]}}</span>
        <div slot="children">
          <div class="summary" :class="{linear:expendDoctorDescription}" @click="onDoctorDescriptionClick(doctor.id)">{{ doctor.description }}</div>
        </div>
      </md-cell-item>
      <md-cell-item v-for="ds of doctorScheduleListByComputed(doctor.id)" :key="ds.id" :title="ds.date + ' ( ' + ds.week + ')'" :addon="ds.restSum>0?('剩余 '+ds.restSum):'满'" @click="clickDoctorScheduleItem(ds.id, doctor.id)" :disable="ds.restSum<1" arrow></md-cell-item>
    </md-field>

    <md-popup v-model="dialogTimeRange" position="bottom" v-if="selectDoctorSchedule.restList !== undefined">
      <md-popup-title-bar
        :title="selectDoctorSchedule.date + ' '+ selectDoctorSchedule.week + ''"
        :describe="selectDoctor.name + ' - ' +  (remoteData.department===undefined?'':remoteData.department.name)"
        ok-text="确定"
        cancel-text="取消"
        large-radius
        @confirm="confirmTimeRangePopUp()"
        @cancel="hideTimeRangePopUp()"
      ></md-popup-title-bar>
      <div class="time-range-popup time-range-popup-bottom">
        <p>上午:</p>
        <template v-for="tr in remoteData.timeRangeList">
          <md-radio-box :key="tr[0]" v-if="tr[0] <= 12" :name="tr[0]" v-model="selectTimeRange" :disabled="selectDoctorSchedule.restList[tr[0]-1]<1">
            <div class="tr-checkbox">{{tr[1]}}<span style="padding-left:20px;"></span>{{selectDoctorSchedule.usedList[tr[0]-1]}}/{{selectDoctorSchedule.usedList[tr[0]-1]+selectDoctorSchedule.restList[tr[0]-1]}}</div>
          </md-radio-box>
        </template>

        <p>下午:</p>
        <template v-for="tr in remoteData.timeRangeList">
          <md-radio-box :key="tr[0]" v-if="tr[0] > 12" :name="tr[0]" v-model="selectTimeRange" :disabled="selectDoctorSchedule.restList[tr[0]-1]<1">
            <div class="tr-checkbox">{{tr[1]}}<span style="padding-left:20px;"></span>{{selectDoctorSchedule.usedList[tr[0]-1]}}/{{selectDoctorSchedule.usedList[tr[0]-1]+selectDoctorSchedule.restList[tr[0]-1]}}</div>
          </md-radio-box>
        </template>

      </div>
    </md-popup>

    <md-popup
      class="inner-popup"
      v-model="popupDoctor.show"
      position="bottom"
    >
      <md-popup-title-bar
        only-close
        large-radius
        :title="popupDoctor.name"
        :describe="popupDoctor.title"
        title-align="left"
        @cancel="popupDoctor.show = false"
      ></md-popup-title-bar>
      <div class="doctorPopup">
        <p>{{popupDoctor.description}}</p>
      </div>
    </md-popup>

  </div>
</template>

<script>
import cookie from "@utils/store/cookie"
import { doctorScheduleOfDepartment } from '../api/daOrder'
import { Toast, TabBar, Field, CellItem, Icon, Popup, PopupTitleBar, Button, RadioBox, Skeleton } from 'mand-mobile'

export default {
  name: 'Department',
  components: {
    [TabBar.name]: TabBar,
    [Field.name]: Field,
    [CellItem.name]: CellItem,
    [Popup.name]: Popup,
    [PopupTitleBar.name]: PopupTitleBar,
    [Button.name]: Button,
    [RadioBox.name]: RadioBox,
    [Icon.name]: Icon,
    [Skeleton.name]: Skeleton
  },
  data () {
    return {
      currentDateBar: '',
      dialogTimeRange: false,
      filterDate: '',
      filterDoctorIdList: [],
      remoteData: [],
      remoteDataLoading: false,
      remoteError: null,
      selectTimeRange: null,
      selectDoctor: {},
      selectDoctorSchedule: {},
      expendDoctorDescription: true,
      popupDoctor: {
        show: false,
        name: '',
        title: '',
        description: ''
      }
    }
  },
  created () {
    const departmentId = this.$route.query.id || null
    if (departmentId === null) {
      this.remoteError = '科室参数错误'
      return
    }

    this.remoteDataLoading = true
    this.remoteError = null
    this.remoteData = []
    doctorScheduleOfDepartment(departmentId)
      .then(res => {
        this.remoteDataLoading = false
        if (res.data && res.status === 200) {
          this.$store.commit("UPDATE_HOSPITAL", res.data.hospital)
          cookie.set('hospital', res.data.hospital.id)
          this.remoteData = res.data
          this.onDateBarChange({ name: '' })
          if (this.remoteData.dateList !== undefined) {
            this.remoteData.dateList.unshift({ name: '', label: '全部 显示' })
          }
        } else {
          this.remoteError = res.msg
        }
      })
      .catch(err => {
        this.remoteDataLoading = false
        if (err.msg) {
          this.remoteError = err.msg
        } else {
          this.remoteError = err
        }
        this.onDateBarChange({ name: '' })
      })
  },
  computed: {
    doctorListByComputed () {
      if (this.remoteData.doctorList === undefined) {
        return []
      }
      const __this = this
      return this.remoteData.doctorList.filter(function (obj) {
        return __this.filterDoctorIdList.indexOf(obj.id) !== -1
      })
    }
  },
  methods: {
    onDoctorDescriptionClick (doctorId) {
      for (const doc of this.remoteData.doctorList) {
        if (doc.id === doctorId) {
          this.popupDoctor.name = doc.name
          this.popupDoctor.title = doc.title
          this.popupDoctor.description = doc.description
          this.popupDoctor.show = true
          break
        }
      }
    },
    hideTimeRangePopUp () {
      this.dialogTimeRange = false
    },
    showTimeRangePopUp () {
      this.dialogTimeRange = true
      this.selectTimeRange = null
    },
    confirmTimeRangePopUp () {
      if (this.selectTimeRange == null || this.selectTimeRange === undefined) {
        Toast.info('请先选择时间段')
        return
      }
      this.$router.push({
        path: 'order-create',
        query: {
          dsid: this.selectDoctorSchedule.id,
          tridx: this.selectTimeRange,
          deptid: this.$route.query.id,
          deptname: this.$route.query.name
        }
      })
    },
    onDateBarChange (item) {
      const date = item.name
      this.filterDoctorIdList = []
      if (date === undefined || date === '') {
        this.filterDate = ''
        if (this.remoteData.doctorList !== undefined) {
          for (const d of this.remoteData.doctorList) {
            this.filterDoctorIdList.push(d.id)
          }
        }
      } else {
        this.filterDate = date
        for (const ds of this.remoteData.doctorScheduleList) {
          if (ds.date === this.filterDate) {
            this.filterDoctorIdList.push(ds.doctorId)
          }
        }
      }
      // this.$forceUpdate()
    },
    doctorScheduleListByComputed (doctorId) {
      if (this.remoteData.doctorScheduleList === undefined) {
        return []
      }
      const __this = this
      return this.remoteData.doctorScheduleList.filter(function (obj) {
        return (__this.filterDate === '' || __this.filterDate === obj.date) && doctorId === obj.doctorId
      })
    },
    clickDoctorScheduleItem (doctorScheduleId, doctorId) {
      this.showTimeRangePopUp()

      this.selectTimeRange = null
      /* for (const ds of this.remoteData.doctorScheduleList) {
        if (ds.id === doctorScheduleId) {
          this.selectDoctorSchedule = ds
          break
        }
      } */
      this.selectDoctorSchedule = this.remoteData.doctorScheduleList.find(item => item.id === doctorScheduleId)
      /* for (const doctor of this.remoteData.doctorList) {
        if (doctor.id === doctorId) {
          this.selectDoctor = doctor
          break
        }
      } */
      this.selectDoctor = this.remoteData.doctorList.find(item => item.id === doctorId)
    },
    onTimeRangeSelected () {
      if (this.selectTimeRange == null || this.selectTimeRange === undefined) {
        Toast.info('请先选择时间段.')
        return
      }
      this.$router.push({
        path: 'order-create',
        query: {
          dsid: this.selectDoctorSchedule.id,
          tridx: this.selectTimeRange,
          deptid: this.$route.query.id,
          deptname: this.$route.query.name
        }
      })
    }
  }
}
</script>

<style scoped>
  .doctorPopup {
    font-size: 0.35rem;
    padding: 0.3rem;
    line-height: 1.8;
  }
  .md-cell-item-children div {
    font-size:0.28rem;
    line-height: 1.5;
    color:#858B9C;
  }
  .md-check-base-box {
    font-size:0.32rem;
    padding: 0.13rem 0.06rem;
    margin: 0.03rem;
    display:block;
    margin: 0.1rem 1.2rem;
  }
  .customDateBar {
    text-align: center;
  }
  .time-range-popup {
    position: relative;
    font-size: 28px;
    font-weight: 500;
    box-sizing: border-box;
    text-align: center;
    background-color: #FFF;
  }
  .time-range-popup-bottom {
    width: 100%;
    padding: 0 0 1rem 0;
  }
  .time-range-popup-bottom p {
    line-height: 50px;
  }
  .tr-checkbox {
    text-align: left;
    padding-left: 1.2rem;
  }

  /* 摘要内容 */
  .summary {
      min-height:50px;
  }
  .summary.linear {
      overflow: hidden;    /* 隐藏溢出内容 */
      display: -webkit-box;    /* 弹性布局 */
      text-overflow: clip;    /* 修剪文本 */
      -webkit-line-clamp: 2;    /* 限制文本仅显示前三行 */
      -webkit-box-orient: vertical;    /* 从上向下垂直排列子元素 */
  }
</style>
